import React from 'react';
import createSvgIcon from '@material-ui/icons/utils/createSvgIcon'

export default createSvgIcon(
  <path transform="scale(0.1875, 0.1875)" d="M63.8 0C28.4 0-.4 28.8-.4 64.2s28.8 64.2 64.2 64.2c35.5 0 64.2-28.8 64.2-64.2C128.1 28.8 99.3 0 63.8 0zm.2 111.7c-6 0-10.5-4.5-10.5-11.1 0-6.3 4.5-10.9 10.5-10.9 6.1 0 10.8 4.6 10.8 10.9 0 6.6-4.7 11.1-10.8 11.1zm9.9-78.6c-2.7 15.1-4.7 30.1-6.9 46.2-.3 1.7-6.1 1.8-6.4 0-2.1-16.1-4.2-31.1-6.9-46.2-1-5.2-1.4-7.7-1.4-10.2 0-3.4 2.4-6 11.5-6 8.8 0 11.5 2.7 11.5 6 0 2.5-.5 5-1.4 10.2z" />
, 'WarningFull');
